// NgModule and angular Modules
import { BrowserModule } from "@angular/platform-browser";
import { NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms"; // <== add the imports!
import { HttpClientModule } from "@angular/common/http";

//CarouselModule
import { CarouselModule } from "ngx-owl-carousel-o";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
// angular fire store
import { AngularFireModule } from "@angular/fire";
import { AngularFirestoreModule } from "@angular/fire/firestore";

// MDBBootstrapModule

import { MDBBootstrapModule } from "angular-bootstrap-md";
//AppRoutingModule
import { AppRoutingModule } from "./app-routing.module";
// MDB Angular Free
import {
  InputsModule,
  InputUtilitiesModule,
  WavesModule,
  ButtonsModule
} from "angular-bootstrap-md";
// AppComponents
import { AppComponent } from "./app.component";
import { NavbarComponent } from "./components/navbar/navbar.component";
import { BooksComponent } from "./components/books/books.component";
import { BookComponent } from "./components/book/book.component";
import { FooterComponent } from "./components/footer/footer.component";
import { SideBarComponent } from "./components/side-bar/side-bar.component";
import { FavoriteBooksComponent } from "./favorite-books/favorite-books.component";
import { AddBookComponent } from "./add-book/add-book.component";
import { EditBookComponent } from "./edit-book/edit-book.component";
import { RecentlyAddedComponent } from "./components/recently-added/recently-added.component";
import { RegisterComponent } from "./components/rigister/rigister.component";
import { LoginComponent } from "./components/login/login.component";
import { NotfoundComponent } from "./components/notfound/notfound.component";
import { environment } from "src/environments/environment";
import { AngularFireAuthModule } from "@angular/fire/auth";
import { LoadingSpinnerComponent } from "./ui/loading-spinner/loading-spinner.component";
import { DashBoardComponent } from "./components/dash-board/dash-board.component";
import { AllBooksComponent } from "./components/dash-board/all-books/all-books.component";
import { NewsComponent } from "./components/news/news.component";
import { PostsComponent } from "./components/dash-board/posts/posts.component";
import { AddPostComponent } from "./components/dash-board/posts/add-post/add-post.component";
import { PostComponent } from "./components/news/post/post.component";
import { UserProfileComponent } from "./components/user/user-profile/user-profile.component";
import { UsersComponent } from "./components/dash-board/users/users.component";
import { UserBooksAComponent } from "./user-books/user-books.component";
@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    BooksComponent,
    BookComponent,
    FooterComponent,
    SideBarComponent,
    FavoriteBooksComponent,
    AddBookComponent,
    EditBookComponent,
    RecentlyAddedComponent,
    RegisterComponent,
    LoginComponent,
    UserBooksAComponent,

    NotfoundComponent,
    LoadingSpinnerComponent,
    DashBoardComponent,
    AllBooksComponent,
    NewsComponent,
    PostsComponent,
    AddPostComponent,
    PostComponent,
    UserProfileComponent,
    UsersComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MDBBootstrapModule.forRoot(),
    CarouselModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonsModule,
    WavesModule,
    InputUtilitiesModule,
    InputsModule,
    HttpClientModule,
    AngularFirestoreModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule
  ],
  schemas: [NO_ERRORS_SCHEMA],

  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
